<template>
	<div class="d-flex justify-content-between">
		<button
			v-shortkey="['ctrl', (index + 1)]"
			@shortkey="playMacro(macro)"
			type="button"
			class="btn btn-macro-list btn-info btn-icon p-0 mr-0"
			:class="{ 'ml-5px': macros.length < 8 && index > 0, 'disabled': macro.status === 'playing' || isFetchingMacros}"
			v-tooltip="macro.name"
			@click="playMacro(macro)"
			v-click-outside="hideContextMacro"
			ref="dropdownContextMacro"
			@contextmenu.prevent
			@contextmenu="toggleContextMacro(macro)"
			>
			<img width="15px" v-if="macro.status === 'playing'" :src="'/img/Rolling-0.7s-45px.svg'">
			<!-- Temp Icon -->
			<template v-if="macro.status === 'idle' || !macro.status">{{ index + 1 }}</template>
			<ul v-if="opened && macroId === macro.id" class="pointer dropdown-context">
				<li>
					<div class="text-white-context text-left pl-4 pb-2 pt-2" @click="playMacro(macro)">{{ $t('Run') }}</div>
				</li>
				<li>
					<div v-if="macro.id !== macroActiveId" class="text-white-context text-left pl-4 pb-2 pt-2" @click.stop="showMacro(macro)">{{ $t('Edit') }}</div>
				</li>
				<li>
					<div v-if="macro.id !== macroActiveId"  class="text-white-context text-left pl-4 pb-2 pt-2" @click.stop="copyPlayMacro(macro)">{{ $t('Copy play URL') }}</div>
				</li>
				<li>
					<div v-if="macro.id !== macroActiveId" class="text-white-context text-left pl-4 pb-2 pt-2" @click.stop="duplicate(macro)">{{ $t('Duplicate') }}</div>
				</li>
				<li>
					<div v-if="macro.id !== macroActiveId"  class="text-white-context text-left pl-4 pb-2 pt-2" @click.stop="confirmRemoveVisibleMacro(macro)">{{ $t('Delete') }}</div>
				</li>
			</ul>
		</button>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
	name: 'MacroButton',
	data() {
		return {
			status: 'idle',
			opened: false,
			macroId: null,
		};
	},
	props: {
		index: {
		},
		macros: {
		},
		macro: {
		},
		macroActiveId: {
		},
		macroStatus: {
		},
		isFetchingMacros: {
		},
	},
	methods: {
		hideContextMacro() {
			this.opened = false;
			this.macroId = null;
		},
		playMacro(macro) {
			const macroItems = macro && macro.macroItems && macro.macroItems.length > 0 ? macro.macroItems : null;
			if (macroItems) {
				this.macro.status = 'playing';
			}
			this.opened = false;
			this.$emit('playMacro', macro);
		},
		showMacro(macro) {
			this.opened = false;
			this.$emit('showMacro', macro);
		},
		duplicate(macro) {
			this.opened = false;
			this.$emit('duplicate', macro);
		},
		copyPlayMacro(macro) {
			this.opened = false;
			this.$emit('copyPlayMacro', macro);
		},
		confirmRemoveVisibleMacro(macro) {
			this.opened = false;
			this.$emit('confirmRemoveVisibleMacro', macro);
		},
		toggleContextMacro(macro) {
			this.macroId = macro.id;
			this.opened = true;
		},
		onClick(e) {
			const el = this.$refs.dropdownContextMacro;
			const target = e.target;
			if ((el !== target) && !el.contains(target)) {
				this.opened = false;
			}
		},
	},
	directives: {
		ClickOutside,
	},
	components: {
	},
	computed: {
	},
	created() {
		window.addEventListener('contextmenu', this.onClick);
	},
	destroyed() {
		window.removeEventListener('contextmenu', this.onClick);
	},
	watch: {
	},
};
</script>
